import { ReactComponent as CheckmarkIcon } from './assets/checkmark.svg';
import { ReactComponent as CKCLogo } from './assets/ckc-logo.svg';

import styles from './sidebar.module.css';

interface UspProps {
  children: string;
}
const UspItem: React.FC<UspProps> = ({ children }: UspProps) => {
  return (
    <li className={styles.uspItem}>
      <CheckmarkIcon className={styles.checkmark} />
      <span>{children}</span>
    </li>
  );
};

const Sidebar: React.FC = () => {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.holder}>
        <div>
          <a
            href="https://ckc-zoetermeer.nl"
            tabIndex={0}
            aria-label="Terug naar CKC &amp; partners"
          >
            <CKCLogo
              className={styles.logo}
              aria-label="CKC &amp; partners logo"
            />
          </a>
        </div>
        <div className={styles.text}>
          <h1 className={styles.heading}>
            Log in op <span>je CKC-account</span>
          </h1>
          <ul className={styles.uspList}>
            <UspItem>Eén account voor het hele gezin</UspItem>
            <UspItem>Eenvoudig aanmelden voor activiteiten</UspItem>
            <UspItem>Wijzigen van je eigen gegevens</UspItem>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
